<template>
  <l-rows>
    <a-title :text="$t('cpv.allowedHashes')" />
    <l-columns space="between">
      <component-select
        v-model="component"
      />
      <a-button
        :text="$t('cpv.addAllowedHash')"
        variant="primary"
        @click="addAllowedHash"
      />
    </l-columns>
    <o-list
      :columns="columns"
      :data="hashes"
      :selectable="false"
      :loading="pageMeta.loading"
    />
  </l-rows>
</template>

<script>
  import { AButton, ATitle, LColumns, LRows, OList } from 'codefabrik-gui-vue'
  import useQuery from 'codefabrik-gui-vue/src/apollo/mixins/useQuery'
  import { reportingService } from '@/services'
  import { ComponentSelect } from '@/components'
  import { useRemoveAllowedHash } from '@/views/cpv/cpvHooks'

  export default {
    name: 'AllowedHashList',
    components: { ComponentSelect, ATitle, LRows, OList, LColumns, AButton },
    data () {
      return {
        component: this.$route.query.component || 'bridge',
      }
    },
    computed: {
      hashes () {
        return this.pageMeta.loading ? [] : this.page.hashes.map(it => ({ hash: it}))
      },
      columns () {
        return [
          {
            header: this.$t('cpv.allowedHash'),
            field: 'hash'
          },
          {
            field: 'hash',
            size: 'narrow',
            component: AButton,
            componentProperties: {
              variant: 'danger',
              iconLeft: 'fas fa-minus',
              'aria-label': 'Remove hash'
            },
            componentListeners: {
              click: this.handleClick
            }
          }
        ]
      },
    },
    methods: {
      addAllowedHash () {
        this.$router.push({ name: 'allowed-hash-add', query: { component: this.component } })
      },
      handleClick ({ hash }) {
        this.removeAllowedHash({ component: this.component, hash: hash})
      }
    },
    mixins: [
      useQuery({
        name: 'page',
        serviceFn: reportingService.getComponentHashPage,
        variables () {
          return {
            input: {
              component: this.component
            }
          }
        }
      }),
      useRemoveAllowedHash()
    ]
  }
</script>

<style scoped>

</style>
